import { Slide } from '@act/storybook';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { actingUserAppSelectors } from 'redux/slices/actingUserSlice';
import { useTheme } from '@mui/material/styles';

export const FundingSlide = () => {
  const theme = useTheme();
  const actingUser = actingUserAppSelectors.useSelectActingUser();
  const { totalMembersServed = 0 } = actingUser?.reecap || {};

  return (
    <Slide gap={2}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.5 }}
      >
        <Typography
          variant="headlineLarge"
          fontSize="48px"
          color="primary.contrastText"
        >
          We got{' '}
          <motion.div
            initial={{ color: theme.palette.primary.contrastText }}
            animate={{ color: theme.palette.primaryAccent.main }}
            transition={{ delay: 4.25, duration: 0.75 }}
            style={{ display: 'inline' }}
          >
            series B
          </motion.div>{' '}
          funding,
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1.5 }}
      >
        <Typography
          variant="headlineLarge"
          fontSize="48px"
          color="primary.contrastText"
        >
          welcomed teams in{' '}
          <motion.div
            initial={{ color: theme.palette.primary.contrastText }}
            animate={{ color: theme.palette.primaryAccent.main }}
            transition={{ delay: 5.25, duration: 0.75 }}
            style={{ display: 'inline' }}
          >
            7
          </motion.div>{' '}
          states,
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 3.0, duration: 1.5 }}
      >
        <Typography
          variant="headlineLarge"
          fontSize="48px"
          color="primary.contrastText"
        >
          and served{' '}
          <motion.div
            initial={{ color: theme.palette.primary.contrastText }}
            animate={{ color: theme.palette.primaryAccent.main }}
            transition={{ delay: 6.5, duration: 0.75 }}
            style={{ display: 'inline' }}
          >
            {totalMembersServed}
          </motion.div>{' '}
          members this year.
        </Typography>
      </motion.div>
    </Slide>
  );
};
